// The ISO country code defined by ISO-3166 returned from the maxminddb
export default function useIpCountryCode() {
  return global.__AT_DATA__.ipCountry;
}
